import React, { Component } from 'react';

import Navigation from './Navigation.js';


class News extends Component {


    constructor(props) {
        super(props);

        this.state = {
            items: [],
            news: [],
            laureate: []
        }
    }

    componentDidMount() {
        fetch('data.json')
            .then((response) => {
                return response.json()
            })
            .then((json) => {
                this.setState({
                    items: json.exposition,
                    news: json.news,
                    laureate: json.laureate
                })
            });
    }

    render() {
        return (
            <div>
                <Navigation />
                <main className="main-content">
                    <section className="section pt-6 my-8 ">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-7 col-xl-6 order-2 order-md-1">
                                    <article className="">
                                        {this.state.news.map((item, index) =>
                                            <div className="card-body" key={index}>
                                                <div className="pb-2">
                                                    <h3>Expositions {item.year}</h3>
                                                </div>
                                                {item.list.map((subitem, index) =>
                                                    <div key={"sub-" + index} className="mb-3">
                                                        <div className="row small-2 mb--5">
                                                            <div className="col-auto">
                                                                <span className="text-inherit text-warning fw-500">{subitem.date}</span>
                                                            </div>
                                                        </div>
                                                        <p className="fw-600 text-dark mb--5">{subitem.name}</p>
                                                        <p className="small-2 m-0">{subitem.position}</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {this.state.items.map((item, index) =>
                                            <div className="card-body" key={index}>
                                                <h5>{item.year}</h5>
                                                {item.list.map((subitem, index) =>
                                                    <div key={"sub-" + index} className="mb-3">

                                                        <p className="m-0 fw-600 text-dark">{subitem.name}</p>
                                                        <div className="row small-2">
                                                            <div className="col-auto">
                                                                <span className="text-inherit">{subitem.date}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row small-2">
                                                            <div className="col-auto">
                                                                <span className="text-inherit">{subitem.position}</span>
                                                            </div>
                                                        </div>
                                                        <h5 className="text-warning">{subitem.laureate}</h5>
                                                    </div>

                                                )}
                                            </div>
                                        )}
                                    </article>

                                </div>
                                <div className="col-md-5 col-xl-6 order-1  order-md-2">
                                    <article className="border border-warning text-center">
                                        <div className="card-body">
                                            {this.state.laureate.map((item, index) =>
                                                <div key={index} className="mb-3">
                                                    <p className="m-0 fw-600 text-dark lead-1">{item.title}</p>
                                                    <div className="small-2">
                                                        <div className="col-auto">
                                                            <span className="text-inherit" href="">{item.content}</span>
                                                        </div>
                                                    </div>
                                                    <div className="small-2">
                                                        <div className="col-auto">
                                                            <span className="text-inherit" href="">{item.position}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </article>

                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                {/* <Footer /> */}
            </div>
        );
    }
}

export default News;



// WEBPACK FOOTER //
// ./src/News.js